export const dlLoginSuccessEvent = (customer) => {
    window.dataLayer.push({
        event: 'login',
        customer
    });
};
